import { NgTemplateOutlet } from '@angular/common';
import { Component, inject } from '@angular/core';

import { ChdCardPresenter } from '@cp-produkte/cruise-hospitality-design';

import { ComponentsModule } from '../components.module';

/**
 * App-local dx renderer that draws `ChdCard` with the legacy `spa-card`.
 * Plugged into the chd card slot via `provideChdDxBackend({ card: ChdCardSpaRenderer })`.
 *
 * Projects card content into `spa-card`; other chd-card features are not supported.
 */
@Component({
  selector: 'spa-chd-card-renderer',
  imports: [ComponentsModule, NgTemplateOutlet],
  templateUrl: './chd-card-spa-renderer.component.html',
  styleUrl: './chd-card-spa-renderer.component.scss',
})
export class ChdCardSpaRenderer {
  protected readonly presenter = inject(ChdCardPresenter);
}
